import AdminSidebar from 'admin/sidebar/AdminSidebar';
import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import Switch from 'react-switch';
import { CiSearch } from 'react-icons/ci';
import { Checkbox } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import DefulatImg from '../../assets/images/PurpleIcon.png';
import axios from 'axios';
import AllGetPromoCode from './AllGetPromoCode';
import { ToastContainer, toast } from 'react-toastify';
import Nodata from '../../assets/images/nodataImg.png';
import './PromoCode.css';
const formatShortDate = (date) => (date ? moment(date).format('DD MMM YYYY') : '—');

const PromoCode = () => {
  const [value, setValue] = useState(moment().toDate());
  const [endValue, setEndValue] = useState(moment().add(7, 'days').toDate());
  const [isSpecificProvider, setIsSpecificProvider] = useState(false);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [applyAtAll, setApplyAtAll] = useState(true);
  const [promoCode, setPromoCode] = useState('');
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState('percentage');
  const [isActive, setIsActive] = useState(true);
  const [multiUse, setMultiUse] = useState(false);
  const [user, setUser] = useState([]);
  const [errors, setErrors] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [listVersion, setListVersion] = useState(0);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const filteredUsers = user.filter((provider) => {
    const term = searchTerm.toLowerCase();
    return (
      provider?.username?.toLowerCase().includes(term) ||
      provider?.email?.toLowerCase().includes(term)
    );
  });

  const handleSwitchChange = () => {
    const newValue = !isSpecificProvider;
    setIsSpecificProvider(newValue);
    if (!newValue) {
      setSelectedProviders([]);
      setApplyAtAll(true);
    } else {
      setApplyAtAll(false);
    }
  };

  const handleSelectProvider = (provider) => {
    setSelectedProviders((prev) =>
      prev.some((p) => p._id === provider._id)
        ? prev.filter((p) => p._id !== provider._id)
        : [...prev, provider]
    );
  };

  const handleDiscountTypeChange = (e) => setDiscountType(e.target.value);

  const validateForm = () => {
    const newErrors = {};
    const promoCodeRegex = /^[A-Za-z0-9]+$/;

    if (!promoCode.trim()) {
      newErrors.promoCode = 'Promo code is required';
    } else if (!promoCodeRegex.test(promoCode)) {
      newErrors.promoCode = 'Promo code must be alphanumeric with no spaces';
    }

    if (!discount.trim() || isNaN(discount) || parseFloat(discount) <= 0)
      newErrors.discount = 'Enter a valid discount value';
    if (!discountType) newErrors.discountType = 'Select a discount type';

    const start = moment(value).startOf('day');
    const end = moment(endValue).endOf('day');
    if (!start.isValid() || !end.isValid()) {
      newErrors.date = 'Start and end date are required';
    } else if (!end.isAfter(start)) {
      newErrors.date = 'End date must be on or after the start date';
    }

    if (isSpecificProvider && selectedProviders.length === 0)
      newErrors.selectedProviders = 'Select at least one customer';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setPromoCode('');
    setDiscount('');
    setDiscountType('percentage');
    setValue(moment().toDate());
    setEndValue(moment().add(7, 'days').toDate());
    setIsActive(true);
    setMultiUse(false);
    setErrors({});
  };

  const handleAcceptClick = async () => {
    if (!validateForm()) return;
    const payload = {
      isActive,
      Discounttype: discountType,
      promoCode,
      discount,
      multiUse,
      duration: {
        startTime: moment(value).startOf('day').utc().toISOString(),
        endTime: moment(endValue).endOf('day').utc().toISOString(),
      },
      giveTo: selectedProviders.length > 0 ? selectedProviders.map((p) => p._id) : [],
      giveToAll: applyAtAll,
    };

    const token = localStorage.getItem('accessTokenAdmin');
    setSubmitting(true);
    try {
      await axios.post('https://production.washta.com/api/admin/promocode', payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      toast.success('Promo code created');
      resetForm();
      setListVersion((v) => v + 1);
    } catch (error) {
      console.error('API Error:', error.response ? error.response.data : error.message);
      toast.error('Could not create promo code');
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      const token = localStorage.getItem('accessTokenAdmin');
      const apiUrl = 'https://production.washta.com/api/admin/customer';

      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(response.data.data.reverse());
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="wp-page">
      <div className='div-sidebar'>
        <AdminSidebar />
      </div>
      <div className='div-Dashbaord' style={{padding:'15px 17px 40px',background:'white'}}>
        <div className="wp-content">
          <div className="wp-header">
            <div>
              <h1 className="sap-title">Promo codes</h1>
              <p className='po-subtitle' style={{paddingBottom:'20px'}}>Create a discount code and choose who it applies to.</p>
            </div>
            <div className="wp-audience-toggle">
              <span>Specific customers</span>
              <Switch
                onChange={handleSwitchChange}
                checked={isSpecificProvider}
                onColor="#6C5CE7"
                offColor="#D8D9E6"
                handleDiameter={17}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 4px rgba(0,0,0,0.25)"
                height={20}
                width={36}
              />
            </div>
          </div>

          <div className="wp-builder">
            {/* -------- Form card -------- */}
            <div className="wp-card">
              <h3 className="wp-card-title">Coupon details</h3>
              <p className='ws-view-sub'>Fill in the details below to generate a new code.</p>

              <div className="wp-audience-row">
                <div>
                  <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--wp-text-muted)' }}>
                    Customers
                  </span>
                  <div className="wp-tags">
                    {applyAtAll ? (
                      <span className="wp-tag">All customers</span>
                    ) : selectedProviders.length > 0 ? (
                      selectedProviders.map((p) => <span className="wp-tag" key={p._id}>{p.username}</span>)
                    ) : (
                      <span className="wp-tag" style={{ background: 'var(--wp-danger-light)', color: 'var(--wp-danger)' }}>
                        None selected
                      </span>
                    )}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => isSpecificProvider && setShowPopup(true)}
                  className="wp-btn wp-btn-ghost"
                  disabled={!isSpecificProvider}
                >
                  Select customers
                </button>
              </div>
              {errors.selectedProviders && <p className="wp-error">{errors.selectedProviders}</p>}

              <div className="wp-form-row">
                <div className="wp-field">
                  <label>Discount type</label>
                  <select value={discountType} onChange={handleDiscountTypeChange}>
                    <option value="" disabled>Select discount type</option>
                    {/* <option value="fixed">Fixed</option> */}
                    <option value="percentage">Percentage</option>
                  </select>
                  {errors.discountType && <p className="wp-error">{errors.discountType}</p>}
                </div>

                <div className="wp-field">
                  <label>Discount</label>
                  <input
                    type="number"
                    placeholder="00.00"
                    value={discount}
                    onChange={(e) => {
    const value = e.target.value;
    if (value === "") {
      setDiscount("");
      return;
    }
    if (Number(value) >= 0) {
      setDiscount(value);
    }
  }}
                  />
                  <span className="wp-suffix">{discountType === 'percentage' ? '%' : 'AED'}</span>
                  {errors.discount && <p className="wp-error">{errors.discount}</p>}
                </div>
              </div>

              <div className="wp-form-row">
                <div className="wp-field">
                  <label>Promo code</label>
                  <input
                    type="text"
                    placeholder="e.g. WASH20"
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value.replace(/\s+/g, ''))}
                  />
                  {errors.promoCode && <p className="wp-error">{errors.promoCode}</p>}
                </div>
                <div />
              </div>

              <div className="wp-form-row">
                <div className="wp-field wp-date">
                  <label>Start date</label>
                  <DatePicker
                    selected={value}
                    onChange={(date) => setValue(date)}
                    selectsStart
                    startDate={value}
                    endDate={endValue}
                    dateFormat="dd MMM yyyy"
                    className="wp-datepicker-input"
                    calendarClassName="wp-datepicker-calendar"
                  />
                </div>
                <div className="wp-field wp-date">
                  <label>End date</label>
                  <DatePicker
                    selected={endValue}
                    onChange={(date) => setEndValue(date)}
                    selectsEnd
                    startDate={value}
                    endDate={endValue}
                    minDate={value}
                    dateFormat="dd MMM yyyy"
                    className="wp-datepicker-input"
                    calendarClassName="wp-datepicker-calendar"
                  />
                </div>
              </div>
              {errors.date && <p className="wp-error" style={{ marginTop: -10, marginBottom: 14 }}>{errors.date}</p>}

              <div className="wp-status-row">
                <div className="wp-status-label">
                  <span>Multiple use</span>
                  <span className='ws-view-sub'>
                    {multiUse
                      ? 'Same customer can use this code more than once during the active period'
                      : 'Each customer can use this code only one time'}
                  </span>
                </div>
                <Switch
                  onChange={() => setMultiUse(!multiUse)}
                  checked={multiUse}
                  onColor="#6C5CE7"
                  offColor="#D8D9E6"
                  handleDiameter={17}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 4px rgba(0,0,0,0.25)"
                  height={20}
                  width={36}
                />
              </div>

              <div className="wp-status-row">
                <div className="wp-status-label">
                  <span>Status</span>
                  <span className='ws-view-sub'>{isActive ? 'Live and usable by customers' : 'Saved but not usable yet'}</span>
                </div>
                <Switch
                  onChange={() => setIsActive(!isActive)}
                  checked={isActive}
                  onColor="#6C5CE7"
                  offColor="#D8D9E6"
                  handleDiameter={17}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 4px rgba(0,0,0,0.25)"
                  height={20}
                  width={36}
                />
              </div>

              <div className="wp-actions">
                <button className="wp-btn wp-btn-primary" onClick={handleAcceptClick} disabled={submitting}>
                  {submitting ? 'Creating…' : 'Create promo code'}
                </button>
              </div>
            </div>

            {/* -------- Live preview -------- */}
            <div className="wp-preview-slot">
              <p className="wp-preview-label">Preview</p>
              <div className="wp-coupon">
                <div className="wp-coupon-stub">
                  <span className="wp-value">{discount || '0'}{discountType === 'percentage' ? '%' : ''}</span>
                  <span className="wp-unit">off</span>
                </div>
                <div className="wp-coupon-divider" />
                <div className="wp-coupon-body">
                  <span className="wp-code">{promoCode || 'YOURCODE'}</span>
                  <div className="wp-meta">
                    {applyAtAll ? 'All customers' : `${selectedProviders.length} customer(s)`}
                    <br />
                    {formatShortDate(value)} – {formatShortDate(endValue)}
                  </div>
                  <div className="wp-badges">
                    <span className={`wp-badge ${isActive ? 'wp-badge-active' : 'wp-badge-inactive'}`}>
                      {isActive ? 'Active' : 'Inactive'}
                    </span>
                    <span className={`wp-badge ${multiUse ? 'wp-badge-active' : 'wp-badge-inactive'}`}>
                      {multiUse ? 'Multi-use' : 'Single-use'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* -------- Existing promo codes -------- */}
          <div className="wp-list-section">
            <div className="wp-list-header">
              <h2 className='sap-title'>All promo codes</h2>
            </div>
            <AllGetPromoCode key={listVersion} />
          </div>
        </div>

        <Modal
          title="Select customers"
          open={showPopup}
          onCancel={() => setShowPopup(false)}
          footer={null}
          centered
        >
          <div className="wp-search-box">
            <CiSearch />
            <input
              type="text"
              placeholder="Search by customer name or email"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          <div className="wp-customer-list">
            {filteredUsers.length > 0 ? (
              filteredUsers.map((provider) => (
                <div
                  className="wp-customer-row"
                  key={provider._id}
                  onClick={() => handleSelectProvider(provider)}
                >
                  <div className="wp-customer-info">
                    <img
                      src={provider.avatar || DefulatImg}
                      className="wp-customer-avatar"
                      alt={provider.username}
                    />
                    <div>
                      <h5>{provider.username}</h5>
                      <p>{provider.email}</p>
                    </div>
                  </div>
                  <Checkbox
                    checked={selectedProviders.some((p) => p._id === provider._id)}
                    onChange={() => handleSelectProvider(provider)}
                  />
                </div>
              ))
            ) : (
              <div className="wp-modal-empty">
                <img src={Nodata} alt="No customers found" />
                <p>No customers found</p>
              </div>
            )}
          </div>
        </Modal>

        <ToastContainer />
      </div>
    </div>
  );
};

export default PromoCode;